/**
 * Quiz Questions Database
 * Generated from edouard.ai blog articles
 * Total: 82 questions
 */

import type { QuizQuestion, QuizCategory } from '../types/quiz';

export const QUIZ_QUESTIONS: QuizQuestion[] = [
  // ========================================
  // BITCOIN (21 questions)
  // ========================================

  {
    id: 'btc-001',
    category: 'bitcoin',
    difficulty: 'easy',
    question: {
      fr: 'En quelle année Bitcoin a-t-il été créé ?',
      en: 'In what year was Bitcoin created?'
    },
    options: {
      fr: ['2007', '2008', '2009', '2010'],
      en: ['2007', '2008', '2009', '2010']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Bitcoin a été créé en 2009 par Satoshi Nakamoto. Le whitepaper a été publié le 31 octobre 2008, mais le réseau a été lancé en janvier 2009 avec le minage du premier bloc (genesis block).',
      en: 'Bitcoin was created in 2009 by Satoshi Nakamoto. The whitepaper was published on October 31, 2008, but the network was launched in January 2009 with the mining of the first block (genesis block).'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-002',
    category: 'bitcoin',
    difficulty: 'easy',
    question: {
      fr: 'Quel est le nombre maximum de bitcoins qui existeront jamais ?',
      en: 'What is the maximum number of bitcoins that will ever exist?'
    },
    options: {
      fr: ['18 millions', '21 millions', '100 millions', 'Illimité'],
      en: ['18 million', '21 million', '100 million', 'Unlimited']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Il n\'existera jamais plus de 21 millions de bitcoins. Cette limite est inscrite dans le code de Bitcoin et représente une des caractéristiques fondamentales garantissant sa rareté.',
      en: 'There will never be more than 21 million bitcoins. This limit is hardcoded into Bitcoin\'s code and represents one of the fundamental characteristics ensuring its scarcity.'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-003',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Comment s\'appelle la plus petite unité de Bitcoin ?',
      en: 'What is the smallest unit of Bitcoin called?'
    },
    options: {
      fr: ['Microbit', 'Satoshi', 'Wei', 'Nano'],
      en: ['Microbit', 'Satoshi', 'Wei', 'Nano']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'La plus petite unité de Bitcoin s\'appelle le satoshi (ou sat), nommée en l\'honneur du créateur Satoshi Nakamoto. 1 Bitcoin = 100 000 000 satoshis (8 décimales).',
      en: 'The smallest unit of Bitcoin is called a satoshi (or sat), named in honor of the creator Satoshi Nakamoto. 1 Bitcoin = 100,000,000 satoshis (8 decimals).'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-004',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Quelle est la récompense actuelle (2024) pour le minage d\'un bloc Bitcoin ?',
      en: 'What is the current (2024) reward for mining a Bitcoin block?'
    },
    options: {
      fr: ['6,25 BTC', '3,125 BTC', '12,5 BTC', '1,5625 BTC'],
      en: ['6.25 BTC', '3.125 BTC', '12.5 BTC', '1.5625 BTC']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Depuis le halving de 2024, la récompense par bloc est de 3,125 BTC. Cette récompense diminue de moitié tous les 4 ans environ (210 000 blocs), un mécanisme appelé "halving".',
      en: 'Since the 2024 halving, the block reward is 3.125 BTC. This reward is cut in half approximately every 4 years (210,000 blocks), a mechanism called "halving".'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-005',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Que signifie la maxime "Not your keys, not your coins" ?',
      en: 'What does the saying "Not your keys, not your coins" mean?'
    },
    options: {
      fr: [
        'Les clés physiques sont nécessaires pour le minage',
        'Si vous ne contrôlez pas vos clés privées, vous ne possédez pas vraiment vos bitcoins',
        'Les clés de chiffrement doivent être changées régulièrement',
        'Seuls les mineurs possèdent les vraies clés'
      ],
      en: [
        'Physical keys are necessary for mining',
        'If you don\'t control your private keys, you don\'t really own your bitcoins',
        'Encryption keys must be changed regularly',
        'Only miners have the real keys'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Cette expression signifie que si vos bitcoins sont sur un exchange ou un service tiers, c\'est eux qui détiennent les clés privées. Vous ne possédez vraiment vos bitcoins que lorsque vous contrôlez vos propres clés.',
      en: 'This expression means that if your bitcoins are on an exchange or a third-party service, they hold the private keys. You only truly own your bitcoins when you control your own keys.'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-006',
    category: 'bitcoin',
    difficulty: 'hard',
    question: {
      fr: 'Quel est le taux d\'imposition (flat tax) sur les plus-values crypto pour les particuliers en France ?',
      en: 'What is the flat tax rate on crypto capital gains for individuals in France?'
    },
    options: {
      fr: ['20%', '25%', '30%', '35%'],
      en: ['20%', '25%', '30%', '35%']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'En France, les plus-values sur cryptomonnaies sont soumises à la flat tax de 30% (PFU), composée de 12,8% d\'impôt sur le revenu et 17,2% de prélèvements sociaux.',
      en: 'In France, crypto capital gains are subject to a 30% flat tax (PFU), consisting of 12.8% income tax and 17.2% social contributions.'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-007',
    category: 'bitcoin',
    difficulty: 'hard',
    question: {
      fr: 'Lors du crash de 2017-2018, de combien Bitcoin a-t-il chuté depuis son plus haut ?',
      en: 'During the 2017-2018 crash, how much did Bitcoin drop from its all-time high?'
    },
    options: {
      fr: ['-65%', '-77%', '-84%', '-90%'],
      en: ['-65%', '-77%', '-84%', '-90%']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Entre décembre 2017 et décembre 2018, Bitcoin a chuté de 84%, passant de 20 000$ à environ 3 200$. Malgré cette baisse massive, il est ensuite remonté à de nouveaux sommets.',
      en: 'Between December 2017 and December 2018, Bitcoin dropped 84%, falling from $20,000 to approximately $3,200. Despite this massive decline, it later recovered to new all-time highs.'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-008',
    category: 'bitcoin',
    difficulty: 'easy',
    question: {
      fr: 'Qu\'est-ce que la stratégie DCA (Dollar-Cost Averaging) ?',
      en: 'What is the DCA (Dollar-Cost Averaging) strategy?'
    },
    options: {
      fr: [
        'Acheter uniquement quand le prix est bas',
        'Vendre au plus haut et acheter au plus bas',
        'Investir un montant fixe régulièrement, indépendamment du prix',
        'Utiliser l\'effet de levier pour maximiser les gains'
      ],
      en: [
        'Only buy when the price is low',
        'Sell at the high and buy at the low',
        'Invest a fixed amount regularly, regardless of price',
        'Use leverage to maximize gains'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Le DCA consiste à investir un montant fixe à intervalles réguliers (ex: 50€ chaque mois), quel que soit le prix. Cette stratégie permet de lisser la volatilité et d\'éviter le stress du timing de marché.',
      en: 'DCA involves investing a fixed amount at regular intervals (e.g., $50 each month), regardless of the price. This strategy helps smooth out volatility and avoid the stress of market timing.'
    },
    articleUrl: 'https://edouard.ai/comprendre-bitcoin-guide-debutant',
    articleTitle: {
      fr: 'Comprendre Bitcoin : Le Guide Complet du Débutant en 2025',
      en: 'Understanding Bitcoin: The Complete Beginner\'s Guide in 2025'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-009',
    category: 'bitcoin',
    difficulty: 'easy',
    question: {
      fr: 'Quel pays est devenu le premier au monde à adopter Bitcoin comme monnaie légale ?',
      en: 'Which country became the first in the world to adopt Bitcoin as legal tender?'
    },
    options: {
      fr: ['Suisse', 'El Salvador', 'Panama', 'Singapour'],
      en: ['Switzerland', 'El Salvador', 'Panama', 'Singapore']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'El Salvador est devenu le 7 septembre 2021 le premier pays au monde à adopter Bitcoin comme monnaie légale, aux côtés du dollar américain, sous l\'impulsion du président Nayib Bukele.',
      en: 'El Salvador became the first country in the world to adopt Bitcoin as legal tender on September 7, 2021, alongside the US dollar, under the leadership of President Nayib Bukele.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-010',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Quel pourcentage du PIB salvadorien représentent les remittances (transferts d\'argent de la diaspora) ?',
      en: 'What percentage of El Salvador\'s GDP do remittances (diaspora money transfers) represent?'
    },
    options: {
      fr: ['~10%', '~24%', '~35%', '~50%'],
      en: ['~10%', '~24%', '~35%', '~50%']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Les transferts d\'argent de la diaspora représentent environ 24% du PIB d\'El Salvador, soit environ 6 milliards de dollars annuels. C\'est l\'une des raisons majeures de l\'adoption de Bitcoin : réduire les frais de transfert.',
      en: 'Diaspora remittances represent about 24% of El Salvador\'s GDP, approximately $6 billion annually. This is one of the main reasons for Bitcoin adoption: reducing transfer fees.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-011',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Comment s\'appelle le wallet officiel développé par El Salvador pour Bitcoin ?',
      en: 'What is the name of the official wallet developed by El Salvador for Bitcoin?'
    },
    options: {
      fr: ['Bukele Wallet', 'Salvador Pay', 'Chivo Wallet', 'Bitcoin Beach'],
      en: ['Bukele Wallet', 'Salvador Pay', 'Chivo Wallet', 'Bitcoin Beach']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Le Chivo Wallet est l\'application officielle développée par le gouvernement salvadorien. Elle permettait la conversion instantanée BTC/USD et offrait un bonus de 30$ en BTC à l\'inscription.',
      en: 'The Chivo Wallet is the official app developed by the Salvadoran government. It allowed instant BTC/USD conversion and offered a $30 BTC bonus upon registration.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-012',
    category: 'bitcoin',
    difficulty: 'hard',
    question: {
      fr: 'Combien de Bitcoin El Salvador détient-il environ dans ses réserves (fin 2024) ?',
      en: 'How much Bitcoin does El Salvador hold approximately in its reserves (end of 2024)?'
    },
    options: {
      fr: ['~1 000 BTC', '~3 500 BTC', '~5 900 BTC', '~10 000 BTC'],
      en: ['~1,000 BTC', '~3,500 BTC', '~5,900 BTC', '~10,000 BTC']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'El Salvador a accumulé environ 5 900 BTC selon les annonces officielles. Avec Bitcoin au-dessus de 100 000$, cette réserve vaut potentiellement plus de 600 millions de dollars.',
      en: 'El Salvador has accumulated approximately 5,900 BTC according to official announcements. With Bitcoin above $100,000, this reserve is potentially worth over $600 million.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-013',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce que le "Volcano Mining" au Salvador ?',
      en: 'What is "Volcano Mining" in El Salvador?'
    },
    options: {
      fr: [
        'Une méthode de refroidissement des mineurs',
        'Le minage Bitcoin utilisant l\'énergie géothermique des volcans',
        'Un programme d\'éducation sur Bitcoin',
        'Une cryptomonnaie locale'
      ],
      en: [
        'A cooling method for miners',
        'Bitcoin mining using geothermal energy from volcanoes',
        'A Bitcoin education program',
        'A local cryptocurrency'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le Volcano Mining est le projet de minage Bitcoin utilisant l\'énergie géothermique des volcans du Salvador. Cette énergie 100% renouvelable offre un coût d\'électricité très bas et une indépendance énergétique.',
      en: 'Volcano Mining is the Bitcoin mining project using geothermal energy from El Salvador\'s volcanoes. This 100% renewable energy offers very low electricity costs and energy independence.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-014',
    category: 'bitcoin',
    difficulty: 'hard',
    question: {
      fr: 'Quel pourcentage de la population salvadorienne utilisait activement Bitcoin selon les études ?',
      en: 'What percentage of the Salvadoran population actively used Bitcoin according to studies?'
    },
    options: {
      fr: ['5-10%', '15-20%', '35-40%', '60-70%'],
      en: ['5-10%', '15-20%', '35-40%', '60-70%']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Malgré 4 millions de téléchargements du Chivo Wallet, seulement 15-20% de la population utilise régulièrement Bitcoin. Beaucoup ont retiré le bonus de 30$ puis désinstallé l\'application.',
      en: 'Despite 4 million Chivo Wallet downloads, only 15-20% of the population regularly uses Bitcoin. Many withdrew the $30 bonus and then uninstalled the app.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-015',
    category: 'bitcoin',
    difficulty: 'easy',
    question: {
      fr: 'Quel village salvadorien a servi de laboratoire pour l\'adoption Bitcoin avant la loi nationale ?',
      en: 'Which Salvadoran village served as a laboratory for Bitcoin adoption before the national law?'
    },
    options: {
      fr: ['San Salvador Beach', 'Bitcoin Beach (El Zonte)', 'Crypto Village', 'Satoshi Town'],
      en: ['San Salvador Beach', 'Bitcoin Beach (El Zonte)', 'Crypto Village', 'Satoshi Town']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Bitcoin Beach (El Zonte) a expérimenté une économie Bitcoin locale dès 2019, avant la loi nationale. Ce succès local a inspiré la politique nationale du président Bukele.',
      en: 'Bitcoin Beach (El Zonte) experimented with a local Bitcoin economy as early as 2019, before the national law. This local success inspired President Bukele\'s national policy.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-016',
    category: 'bitcoin',
    difficulty: 'hard',
    question: {
      fr: 'Quel pourcentage de la population salvadorienne n\'avait pas de compte bancaire avant Bitcoin ?',
      en: 'What percentage of the Salvadoran population did not have a bank account before Bitcoin?'
    },
    options: {
      fr: ['30%', '50%', '70%', '90%'],
      en: ['30%', '50%', '70%', '90%']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Environ 70% de la population salvadorienne était non-bancarisée avant l\'adoption de Bitcoin. L\'inclusion financière était l\'un des arguments majeurs pour l\'adoption de la cryptomonnaie.',
      en: 'About 70% of the Salvadoran population was unbanked before Bitcoin adoption. Financial inclusion was one of the major arguments for adopting the cryptocurrency.'
    },
    articleUrl: 'https://edouard.ai/el-salvador-bilan-experience-bitcoin',
    articleTitle: {
      fr: 'El Salvador : Bilan de l\'Expérience Bitcoin après 4 Ans',
      en: 'El Salvador: Bitcoin Experiment Review After 4 Years'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-017',
    category: 'bitcoin',
    difficulty: 'hard',
    question: {
      fr: 'Combien de BTC les États-Unis détiennent-ils environ (provenant de saisies judiciaires) ?',
      en: 'How much BTC does the United States hold approximately (from judicial seizures)?'
    },
    options: {
      fr: ['~50 000 BTC', '~100 000 BTC', '~200 000 BTC', '~500 000 BTC'],
      en: ['~50,000 BTC', '~100,000 BTC', '~200,000 BTC', '~500,000 BTC']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Les États-Unis détiennent environ 200 000 BTC provenant de saisies judiciaires (Silk Road, etc.). Un projet de "Strategic Bitcoin Reserve" est en discussion pour officialiser ces réserves.',
      en: 'The United States holds approximately 200,000 BTC from judicial seizures (Silk Road, etc.). A "Strategic Bitcoin Reserve" project is under discussion to formalize these reserves.'
    },
    articleUrl: 'https://edouard.ai/bitcoin-etats-adoption-mondiale',
    articleTitle: {
      fr: 'Bitcoin et les États : La Course Mondiale à l\'Adoption',
      en: 'Bitcoin and Nations: The Global Race to Adoption'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-018',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Quelle région domine actuellement le hashrate Bitcoin mondial ?',
      en: 'Which region currently dominates the global Bitcoin hashrate?'
    },
    options: {
      fr: ['Chine', 'Europe', 'États-Unis', 'Amérique du Sud'],
      en: ['China', 'Europe', 'United States', 'South America']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Les États-Unis dominent le hashrate mondial depuis l\'exode des mineurs chinois en 2021 après l\'interdiction du mining en Chine. Les USA et la Chine représentent ensemble environ 60% du hashrate mondial.',
      en: 'The United States has dominated the global hashrate since the exodus of Chinese miners in 2021 after China banned mining. The USA and China together represent about 60% of the global hashrate.'
    },
    articleUrl: 'https://edouard.ai/bitcoin-etats-adoption-mondiale',
    articleTitle: {
      fr: 'Bitcoin et les États : La Course Mondiale à l\'Adoption',
      en: 'Bitcoin and Nations: The Global Race to Adoption'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-019',
    category: 'bitcoin',
    difficulty: 'easy',
    question: {
      fr: 'Quel canton suisse est connu comme un hub crypto majeur ?',
      en: 'Which Swiss canton is known as a major crypto hub?'
    },
    options: {
      fr: ['Genève', 'Zurich', 'Zoug', 'Berne'],
      en: ['Geneva', 'Zurich', 'Zug', 'Bern']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Le canton de Zoug (Zug) est surnommé "Crypto Valley" et est l\'un des hubs crypto les plus importants au monde grâce à sa fiscalité claire et son cadre réglementaire favorable.',
      en: 'The canton of Zug is nicknamed "Crypto Valley" and is one of the most important crypto hubs in the world thanks to its clear tax policies and favorable regulatory framework.'
    },
    articleUrl: 'https://edouard.ai/bitcoin-etats-adoption-mondiale',
    articleTitle: {
      fr: 'Bitcoin et les États : La Course Mondiale à l\'Adoption',
      en: 'Bitcoin and Nations: The Global Race to Adoption'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-020',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Quelle est la position actuelle de la Chine sur Bitcoin ?',
      en: 'What is China\'s current position on Bitcoin?'
    },
    options: {
      fr: [
        'Adoption comme monnaie légale',
        'Régulation favorable',
        'Interdiction du trading et du mining',
        'Aucune réglementation'
      ],
      en: [
        'Adoption as legal tender',
        'Favorable regulation',
        'Ban on trading and mining',
        'No regulation'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'La Chine a interdit le trading et le mining de Bitcoin en 2021. Cependant, elle détient encore d\'importantes réserves issues de saisies et développe son propre yuan numérique (CBDC).',
      en: 'China banned Bitcoin trading and mining in 2021. However, it still holds significant reserves from seizures and is developing its own digital yuan (CBDC).'
    },
    articleUrl: 'https://edouard.ai/bitcoin-etats-adoption-mondiale',
    articleTitle: {
      fr: 'Bitcoin et les États : La Course Mondiale à l\'Adoption',
      en: 'Bitcoin and Nations: The Global Race to Adoption'
    },
    projectTag: 'bitcoin'
  },
  {
    id: 'btc-021',
    category: 'bitcoin',
    difficulty: 'medium',
    question: {
      fr: 'Quel texte européen encadre les crypto-actifs de manière harmonisée ?',
      en: 'Which European regulation provides a harmonized framework for crypto-assets?'
    },
    options: {
      fr: ['GDPR', 'MiCA', 'PSD2', 'SEPA'],
      en: ['GDPR', 'MiCA', 'PSD2', 'SEPA']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'MiCA (Markets in Crypto-Assets) est le règlement européen qui crée un cadre harmonisé pour les crypto-actifs dans l\'UE, applicable à partir de 2024-2025.',
      en: 'MiCA (Markets in Crypto-Assets) is the European regulation that creates a harmonized framework for crypto-assets in the EU, applicable from 2024-2025.'
    },
    articleUrl: 'https://edouard.ai/bitcoin-etats-adoption-mondiale',
    articleTitle: {
      fr: 'Bitcoin et les États : La Course Mondiale à l\'Adoption',
      en: 'Bitcoin and Nations: The Global Race to Adoption'
    },
    projectTag: 'bitcoin'
  },

  // ========================================
  // BLOCKCHAIN BASICS (8 questions)
  // ========================================

  {
    id: 'bb-001',
    category: 'blockchain-basics',
    difficulty: 'easy',
    question: {
      fr: 'Qu\'est-ce qu\'une blockchain ?',
      en: 'What is a blockchain?'
    },
    options: {
      fr: [
        'Un type de cryptomonnaie',
        'Un registre numérique partagé, transparent et inaltérable',
        'Un logiciel de minage',
        'Une banque en ligne'
      ],
      en: [
        'A type of cryptocurrency',
        'A shared, transparent, and immutable digital ledger',
        'Mining software',
        'An online bank'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'La blockchain est un registre numérique distribué où les transactions sont regroupées en blocs liés cryptographiquement. Elle est partagée entre de nombreux ordinateurs et ses données sont immuables une fois enregistrées.',
      en: 'A blockchain is a distributed digital ledger where transactions are grouped into cryptographically linked blocks. It is shared among many computers and its data is immutable once recorded.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },
  {
    id: 'bb-002',
    category: 'blockchain-basics',
    difficulty: 'easy',
    question: {
      fr: 'Toutes les blockchains utilisent-elles le même mécanisme de consensus ?',
      en: 'Do all blockchains use the same consensus mechanism?'
    },
    options: {
      fr: [
        'Oui, elles utilisent toutes le Proof of Work',
        'Non, il existe différents mécanismes comme Proof of Work et Proof of Stake',
        'Oui, elles utilisent toutes le Proof of Stake',
        'Non, mais seul le Proof of Work est sécurisé'
      ],
      en: [
        'Yes, they all use Proof of Work',
        'No, there are different mechanisms like Proof of Work and Proof of Stake',
        'Yes, they all use Proof of Stake',
        'No, but only Proof of Work is secure'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Il existe plusieurs mécanismes de consensus. Bitcoin utilise le Proof of Work (preuve de travail), tandis qu\'Ethereum est passé au Proof of Stake (preuve d\'enjeu). Chaque mécanisme a ses avantages et inconvénients.',
      en: 'There are several consensus mechanisms. Bitcoin uses Proof of Work, while Ethereum has switched to Proof of Stake. Each mechanism has its advantages and disadvantages.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },
  {
    id: 'bb-003',
    category: 'blockchain-basics',
    difficulty: 'medium',
    question: {
      fr: 'Environ toutes les combien de minutes un nouveau bloc est-il créé sur Bitcoin ?',
      en: 'Approximately how often is a new block created on Bitcoin?'
    },
    options: {
      fr: ['1 minute', '5 minutes', '10 minutes', '30 minutes'],
      en: ['1 minute', '5 minutes', '10 minutes', '30 minutes']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Sur Bitcoin, un nouveau bloc est créé environ toutes les 10 minutes. La difficulté du minage s\'ajuste automatiquement pour maintenir ce rythme stable, quel que soit le nombre de mineurs.',
      en: 'On Bitcoin, a new block is created approximately every 10 minutes. Mining difficulty automatically adjusts to maintain this stable rate, regardless of the number of miners.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },
  {
    id: 'bb-004',
    category: 'blockchain-basics',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce qu\'un hash dans le contexte de la blockchain ?',
      en: 'What is a hash in the context of blockchain?'
    },
    options: {
      fr: [
        'Un type de cryptomonnaie',
        'Une empreinte numérique unique générée à partir de données',
        'Un compte utilisateur',
        'Une transaction en attente'
      ],
      en: [
        'A type of cryptocurrency',
        'A unique digital fingerprint generated from data',
        'A user account',
        'A pending transaction'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Un hash est une empreinte numérique de taille fixe, générée par une fonction de hachage. Il est déterministe (même entrée = même sortie), irréversible, et le moindre changement dans les données produit un hash complètement différent.',
      en: 'A hash is a fixed-size digital fingerprint generated by a hash function. It is deterministic (same input = same output), irreversible, and any change in the data produces a completely different hash.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },
  {
    id: 'bb-005',
    category: 'blockchain-basics',
    difficulty: 'medium',
    question: {
      fr: 'Quelle est la différence entre une blockchain publique et privée ?',
      en: 'What is the difference between a public and private blockchain?'
    },
    options: {
      fr: [
        'La blockchain publique est payante, la privée est gratuite',
        'La blockchain publique est ouverte à tous, la privée nécessite une autorisation',
        'La blockchain privée est plus sécurisée',
        'Il n\'y a pas de différence'
      ],
      en: [
        'Public blockchain is paid, private is free',
        'Public blockchain is open to everyone, private requires authorization',
        'Private blockchain is more secure',
        'There is no difference'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Une blockchain publique (comme Bitcoin) est ouverte à tous sans permission. Une blockchain privée (comme Hyperledger) est contrôlée par une entité et nécessite une autorisation pour participer. Cela impacte la décentralisation et la gouvernance.',
      en: 'A public blockchain (like Bitcoin) is open to everyone without permission. A private blockchain (like Hyperledger) is controlled by an entity and requires authorization to participate. This impacts decentralization and governance.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },
  {
    id: 'bb-006',
    category: 'blockchain-basics',
    difficulty: 'hard',
    question: {
      fr: 'Combien de transactions par seconde Bitcoin peut-il traiter environ ?',
      en: 'Approximately how many transactions per second can Bitcoin process?'
    },
    options: {
      fr: [
        '7 transactions/seconde',
        '100 transactions/seconde',
        '1 000 transactions/seconde',
        '65 000 transactions/seconde'
      ],
      en: [
        '7 transactions/second',
        '100 transactions/second',
        '1,000 transactions/second',
        '65,000 transactions/second'
      ]
    },
    correctAnswer: 0,
    explanation: {
      fr: 'Bitcoin ne peut traiter qu\'environ 7 transactions par seconde (TPS) sur sa chaîne principale. C\'est bien moins que Visa (~65 000 TPS), d\'où l\'importance des solutions Layer 2 comme Lightning Network.',
      en: 'Bitcoin can only process about 7 transactions per second (TPS) on its main chain. This is much less than Visa (~65,000 TPS), hence the importance of Layer 2 solutions like Lightning Network.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },
  {
    id: 'bb-007',
    category: 'blockchain-basics',
    difficulty: 'hard',
    question: {
      fr: 'Qu\'est-ce que le "trilemme de la blockchain" ?',
      en: 'What is the "blockchain trilemma"?'
    },
    options: {
      fr: [
        'Le choix entre 3 cryptomonnaies différentes',
        'L\'impossibilité d\'optimiser décentralisation, sécurité et performance simultanément',
        'Les 3 types de wallets disponibles',
        'Les 3 phases de validation d\'une transaction'
      ],
      en: [
        'The choice between 3 different cryptocurrencies',
        'The impossibility of optimizing decentralization, security, and performance simultaneously',
        'The 3 types of wallets available',
        'The 3 phases of transaction validation'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le trilemme de la blockchain stipule qu\'une blockchain ne peut optimiser que deux des trois aspects suivants : décentralisation, sécurité et performance. Par exemple, Bitcoin privilégie décentralisation + sécurité, mais est lent.',
      en: 'The blockchain trilemma states that a blockchain can only optimize two of the following three aspects: decentralization, security, and performance. For example, Bitcoin prioritizes decentralization + security, but is slow.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },
  {
    id: 'bb-008',
    category: 'blockchain-basics',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce qu\'un nœud (node) dans une blockchain ?',
      en: 'What is a node in a blockchain?'
    },
    options: {
      fr: [
        'Une unité de cryptomonnaie',
        'Un ordinateur participant au réseau qui valide et relaie les transactions',
        'Un type de transaction',
        'Une récompense de minage'
      ],
      en: [
        'A unit of cryptocurrency',
        'A computer participating in the network that validates and relays transactions',
        'A type of transaction',
        'A mining reward'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Un nœud est un ordinateur participant au réseau blockchain. Les nœuds complets stockent l\'intégralité de la blockchain et vérifient toutes les transactions, contribuant à la décentralisation et la sécurité du réseau.',
      en: 'A node is a computer participating in the blockchain network. Full nodes store the entire blockchain and verify all transactions, contributing to the decentralization and security of the network.'
    },
    articleUrl: 'https://edouard.ai/quest-ce-quune-blockchain',
    articleTitle: {
      fr: 'Qu\'est-ce qu\'une Blockchain ? Explication Simple et Complète',
      en: 'What is a Blockchain? Simple and Complete Explanation'
    }
  },

  // ========================================
  // SECURITY (16 questions)
  // ========================================

  {
    id: 'security-001',
    category: 'security',
    difficulty: 'easy',
    question: {
      fr: 'Pourquoi est-il risqué de laisser ses cryptos sur un exchange ?',
      en: 'Why is it risky to leave your crypto on an exchange?'
    },
    options: {
      fr: [
        'Les exchanges ont des frais trop élevés',
        'L\'exchange peut être piraté ou faire faillite, vous faisant perdre vos fonds',
        'Les transactions sont plus lentes',
        'On ne peut pas voir son solde'
      ],
      en: [
        'Exchanges have fees that are too high',
        'The exchange can be hacked or go bankrupt, causing you to lose your funds',
        'Transactions are slower',
        'You cannot see your balance'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Laisser ses cryptos sur un exchange expose à deux risques majeurs : le piratage (comme Mt. Gox qui a perdu 850 000 BTC) et la faillite (comme FTX avec ~8 milliards $ de pertes). "Not your keys, not your coins".',
      en: 'Leaving your crypto on an exchange exposes you to two major risks: hacking (like Mt. Gox which lost 850,000 BTC) and bankruptcy (like FTX with ~$8 billion in losses). "Not your keys, not your coins".'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-002',
    category: 'security',
    difficulty: 'easy',
    question: {
      fr: 'Où ne faut-il JAMAIS stocker sa seed phrase ?',
      en: 'Where should you NEVER store your seed phrase?'
    },
    options: {
      fr: [
        'Sur un papier dans un coffre-fort',
        'Gravée sur une plaque en métal',
        'Dans un fichier sur son ordinateur ou dans le cloud',
        'Répartie entre plusieurs emplacements sécurisés'
      ],
      en: [
        'On paper in a safe',
        'Engraved on a metal plate',
        'In a file on your computer or in the cloud',
        'Distributed across multiple secure locations'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Il ne faut jamais stocker sa seed phrase numériquement (ordinateur, cloud, email, photo). Ces supports sont vulnérables au piratage. Préférez le papier ou le métal, dans des endroits sécurisés physiquement.',
      en: 'Never store your seed phrase digitally (computer, cloud, email, photo). These media are vulnerable to hacking. Prefer paper or metal, in physically secure locations.'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-003',
    category: 'security',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce qu\'une attaque "SIM swap" ?',
      en: 'What is a "SIM swap" attack?'
    },
    options: {
      fr: [
        'Pirater la carte SIM d\'un téléphone à distance',
        'Convaincre l\'opérateur de transférer un numéro vers une autre SIM pour intercepter les SMS',
        'Cloner physiquement une carte SIM',
        'Bloquer le réseau mobile'
      ],
      en: [
        'Hacking a phone\'s SIM card remotely',
        'Convincing the carrier to transfer a number to another SIM to intercept SMS',
        'Physically cloning a SIM card',
        'Blocking the mobile network'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le SIM swap consiste à se faire passer pour vous auprès de votre opérateur pour faire transférer votre numéro sur une SIM contrôlée par l\'attaquant. Il peut ensuite recevoir vos codes 2FA par SMS. C\'est pourquoi il faut éviter le 2FA par SMS.',
      en: 'SIM swap involves impersonating you to your carrier to transfer your number to a SIM controlled by the attacker. They can then receive your 2FA codes via SMS. This is why you should avoid SMS-based 2FA.'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-004',
    category: 'security',
    difficulty: 'medium',
    question: {
      fr: 'Que signifie FOMO dans le contexte crypto ?',
      en: 'What does FOMO mean in the crypto context?'
    },
    options: {
      fr: [
        'First Order Market Operation',
        'Fear Of Missing Out - La peur de rater une opportunité',
        'Financial Options for Maximum Output',
        'Full On Market Order'
      ],
      en: [
        'First Order Market Operation',
        'Fear Of Missing Out - The fear of missing an opportunity',
        'Financial Options for Maximum Output',
        'Full On Market Order'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'FOMO (Fear Of Missing Out) est la peur de rater une opportunité. Elle pousse souvent à acheter impulsivement quand les prix montent, ce qui conduit généralement à acheter au plus haut. C\'est l\'une des erreurs émotionnelles les plus coûteuses.',
      en: 'FOMO (Fear Of Missing Out) is the fear of missing an opportunity. It often leads to impulsive buying when prices rise, which usually means buying at the top. It\'s one of the most costly emotional mistakes.'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-005',
    category: 'security',
    difficulty: 'medium',
    question: {
      fr: 'Pourquoi le day trading est-il très risqué pour les débutants ?',
      en: 'Why is day trading very risky for beginners?'
    },
    options: {
      fr: [
        'Les frais sont plus élevés le matin',
        '95% des day traders perdent de l\'argent et les frais mangent les profits',
        'C\'est illégal dans certains pays',
        'Les marchés sont fermés la nuit'
      ],
      en: [
        'Fees are higher in the morning',
        '95% of day traders lose money and fees eat into profits',
        'It\'s illegal in some countries',
        'Markets are closed at night'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Les études montrent que 95-97% des day traders perdent de l\'argent. Les frais de transaction, le stress, les implications fiscales et le manque d\'outils professionnels rendent cette pratique très défavorable aux particuliers.',
      en: 'Studies show that 95-97% of day traders lose money. Transaction fees, stress, tax implications, and lack of professional tools make this practice very unfavorable for individuals.'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-006',
    category: 'security',
    difficulty: 'hard',
    question: {
      fr: 'Quelle est l\'amende pour non-déclaration d\'un compte crypto sur une plateforme étrangère en France ?',
      en: 'What is the fine for not declaring a crypto account on a foreign platform in France?'
    },
    options: {
      fr: ['500€ par compte/an', '1 000€ par compte/an', '1 500€ par compte/an', '5 000€ par compte/an'],
      en: ['€500 per account/year', '€1,000 per account/year', '€1,500 per account/year', '€5,000 per account/year']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'En France, ne pas déclarer un compte sur un exchange étranger (formulaire 3916-bis) expose à une amende de 1 500€ par compte et par année. Cette obligation s\'applique même si vous n\'avez réalisé aucune plus-value.',
      en: 'In France, failing to declare an account on a foreign exchange (form 3916-bis) exposes you to a fine of €1,500 per account per year. This obligation applies even if you have not made any capital gains.'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-007',
    category: 'security',
    difficulty: 'hard',
    question: {
      fr: 'Combien de BTC sont estimés perdus définitivement ?',
      en: 'How many BTC are estimated to be permanently lost?'
    },
    options: {
      fr: ['500 000 BTC', '1-2 millions de BTC', '3-4 millions de BTC', '10 millions de BTC'],
      en: ['500,000 BTC', '1-2 million BTC', '3-4 million BTC', '10 million BTC']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'On estime que 3 à 4 millions de BTC sont perdus à jamais (clés privées perdues, décès sans transmission, envoi à de mauvaises adresses). Cela représente environ 15-20% de l\'offre totale et renforce la rareté de Bitcoin.',
      en: 'It is estimated that 3 to 4 million BTC are lost forever (lost private keys, death without transfer, sent to wrong addresses). This represents about 15-20% of the total supply and reinforces Bitcoin\'s scarcity.'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-008',
    category: 'security',
    difficulty: 'easy',
    question: {
      fr: 'Quelle est la règle d\'or concernant l\'investissement en crypto ?',
      en: 'What is the golden rule for investing in crypto?'
    },
    options: {
      fr: [
        'Investir tout son argent pour maximiser les gains',
        'N\'investir que ce que vous pouvez perdre',
        'Emprunter pour investir plus',
        'Suivre les conseils des influenceurs'
      ],
      en: [
        'Invest all your money to maximize gains',
        'Only invest what you can afford to lose',
        'Borrow to invest more',
        'Follow influencers\' advice'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'La règle d\'or est de n\'investir que l\'argent que vous pouvez perdre sans que cela n\'affecte votre vie quotidienne. Bitcoin peut perdre 50-80% de sa valeur lors des cycles baissiers. Avoir un fonds d\'urgence avant d\'investir est essentiel.',
      en: 'The golden rule is to only invest money you can afford to lose without affecting your daily life. Bitcoin can lose 50-80% of its value during bear cycles. Having an emergency fund before investing is essential.'
    },
    articleUrl: 'https://edouard.ai/erreurs-eviter-crypto-debutant',
    articleTitle: {
      fr: 'Les Erreurs à Éviter en Crypto',
      en: 'Mistakes to Avoid in Crypto'
    }
  },
  {
    id: 'security-009',
    category: 'security',
    difficulty: 'easy',
    question: {
      fr: 'Qu\'est-ce qu\'une seed phrase ?',
      en: 'What is a seed phrase?'
    },
    options: {
      fr: [
        'Un mot de passe pour se connecter à un exchange',
        'Une liste de 12 ou 24 mots permettant de restaurer un wallet crypto',
        'Un code de sécurité envoyé par SMS',
        'Le nom d\'une cryptomonnaie'
      ],
      en: [
        'A password to log into an exchange',
        'A list of 12 or 24 words to restore a crypto wallet',
        'A security code sent by SMS',
        'The name of a cryptocurrency'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Une seed phrase (phrase de récupération) est une liste de 12 ou 24 mots générés selon le standard BIP-39. Elle permet de restaurer l\'ensemble de vos wallets et fonds sur n\'importe quel appareil compatible.',
      en: 'A seed phrase (recovery phrase) is a list of 12 or 24 words generated according to the BIP-39 standard. It allows you to restore all your wallets and funds on any compatible device.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },
  {
    id: 'security-010',
    category: 'security',
    difficulty: 'hard',
    question: {
      fr: 'Combien de bitcoins sont estimés définitivement perdus à cause de seed phrases perdues ?',
      en: 'How many bitcoins are estimated to be permanently lost due to lost seed phrases?'
    },
    options: {
      fr: ['500 000 - 1 million', '3 - 4 millions', '10 millions', '15 millions'],
      en: ['500,000 - 1 million', '3 - 4 million', '10 million', '15 million']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Entre 3 et 4 millions de Bitcoin sont considérés comme définitivement perdus, majoritairement à cause de seed phrases non sauvegardées ou oubliées. À 100 000$ le BTC, cela représente plus de 300 milliards de dollars volatilisés.',
      en: 'Between 3 and 4 million Bitcoin are considered permanently lost, mainly due to unsaved or forgotten seed phrases. At $100,000 per BTC, this represents over $300 billion gone.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },
  {
    id: 'security-011',
    category: 'security',
    difficulty: 'medium',
    question: {
      fr: 'Quel est le meilleur support pour stocker une seed phrase sur le long terme ?',
      en: 'What is the best medium for storing a seed phrase long-term?'
    },
    options: {
      fr: [
        'Un fichier texte sur son ordinateur',
        'Une photo sur son téléphone',
        'Une plaque en métal (acier ou titane)',
        'Un email à soi-même'
      ],
      en: [
        'A text file on your computer',
        'A photo on your phone',
        'A metal plate (steel or titanium)',
        'An email to yourself'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Les plaques métalliques (acier inoxydable ou titane) sont la référence pour le stockage long terme. Elles résistent aux incendies (jusqu\'à 1400-1670°C), aux inondations et à la corrosion. Le papier et le numérique sont beaucoup plus fragiles.',
      en: 'Metal plates (stainless steel or titanium) are the reference for long-term storage. They resist fires (up to 1400-1670°C), floods, and corrosion. Paper and digital media are much more fragile.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },
  {
    id: 'security-012',
    category: 'security',
    difficulty: 'easy',
    question: {
      fr: 'Combien de copies minimum de sa seed phrase doit-on conserver ?',
      en: 'How many copies of your seed phrase should you keep at minimum?'
    },
    options: {
      fr: ['1 seule suffit', '2 minimum', '5 minimum', '10 minimum'],
      en: ['1 is enough', '2 minimum', '5 minimum', '10 minimum']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Il faut minimum 2 copies de sa seed phrase, idéalement 3. Une seule copie est un risque majeur (perte, destruction). Plus de 4-5 devient difficile à gérer et augmente le risque de fuite.',
      en: 'You need at least 2 copies of your seed phrase, ideally 3. A single copy is a major risk (loss, destruction). More than 4-5 becomes difficult to manage and increases the risk of leakage.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },
  {
    id: 'security-013',
    category: 'security',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce que le Shamir Secret Sharing (SSS) pour les seed phrases ?',
      en: 'What is Shamir Secret Sharing (SSS) for seed phrases?'
    },
    options: {
      fr: [
        'Un nouveau type de cryptomonnaie',
        'Une méthode pour diviser la seed en fragments nécessitant plusieurs parties pour la reconstituer',
        'Un exchange décentralisé',
        'Une application mobile de backup'
      ],
      en: [
        'A new type of cryptocurrency',
        'A method to split the seed into fragments requiring multiple parts to reconstruct',
        'A decentralized exchange',
        'A mobile backup application'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le Shamir Secret Sharing permet de diviser la seed en N fragments dont M sont nécessaires pour reconstituer l\'original (ex: 2-of-3). Un seul fragment est inutile, ce qui améliore sécurité et résilience.',
      en: 'Shamir Secret Sharing allows splitting the seed into N fragments of which M are needed to reconstruct the original (e.g., 2-of-3). A single fragment is useless, improving security and resilience.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },
  {
    id: 'security-014',
    category: 'security',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce que la passphrase (25ème mot) ajoute à une seed phrase ?',
      en: 'What does the passphrase (25th word) add to a seed phrase?'
    },
    options: {
      fr: [
        'Rien, c\'est juste décoratif',
        'Elle génère un wallet caché différent avec la même seed',
        'Elle accélère les transactions',
        'Elle supprime les frais de réseau'
      ],
      en: [
        'Nothing, it\'s just decorative',
        'It generates a different hidden wallet with the same seed',
        'It speeds up transactions',
        'It removes network fees'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'La passphrase (25ème mot) génère un wallet complètement différent à partir de la même seed. Un attaquant ayant la seed mais pas la passphrase ne peut pas accéder aux fonds. Elle permet aussi de créer un wallet leurre.',
      en: 'The passphrase (25th word) generates a completely different wallet from the same seed. An attacker with the seed but not the passphrase cannot access the funds. It also allows creating a decoy wallet.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },
  {
    id: 'security-015',
    category: 'security',
    difficulty: 'hard',
    question: {
      fr: 'Jusqu\'à quelle température résiste une plaque en acier inoxydable ?',
      en: 'Up to what temperature can a stainless steel plate withstand?'
    },
    options: {
      fr: ['~200°C', '~500°C', '~1400°C', '~3000°C'],
      en: ['~200°C', '~500°C', '~1400°C', '~3000°C']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'L\'acier inoxydable résiste jusqu\'à environ 1400°C, bien au-delà des températures d\'un incendie domestique (800-1000°C). Le titane résiste encore mieux (~1670°C). Le papier brûle à seulement 230°C.',
      en: 'Stainless steel withstands up to about 1400°C, well beyond house fire temperatures (800-1000°C). Titanium is even better (~1670°C). Paper burns at only 230°C.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },
  {
    id: 'security-016',
    category: 'security',
    difficulty: 'easy',
    question: {
      fr: 'Où ne faut-il JAMAIS stocker sa seed phrase numériquement ?',
      en: 'Where should you NEVER store your seed phrase digitally?'
    },
    options: {
      fr: [
        'Sur un container VeraCrypt chiffré hors ligne',
        'Dans un email, une photo, ou le cloud',
        'Sur un ordinateur air-gapped',
        'Dans une base KeePassXC locale'
      ],
      en: [
        'In an offline encrypted VeraCrypt container',
        'In an email, a photo, or the cloud',
        'On an air-gapped computer',
        'In a local KeePassXC database'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Il ne faut JAMAIS stocker sa seed dans un email, une photo, le cloud, ou un document non chiffré. Ces supports sont synchronisés, sauvegardés automatiquement, et accessibles aux malwares. Le stockage numérique sécurisé requiert un chiffrement fort et un appareil hors ligne.',
      en: 'NEVER store your seed in an email, photo, cloud, or unencrypted document. These are synced, automatically backed up, and accessible to malware. Secure digital storage requires strong encryption and an offline device.'
    },
    articleUrl: 'https://edouard.ai/stockage-seed-phrase-methodes-supports',
    articleTitle: {
      fr: 'Stockage de Seed Phrase : Guide Complet des Méthodes et Supports',
      en: 'Seed Phrase Storage: Complete Guide to Methods and Media'
    }
  },

  // ========================================
  // GENERAL (22 questions)
  // ========================================

  {
    id: 'gen-001',
    category: 'general',
    difficulty: 'easy',
    question: {
      fr: 'Que signifie l\'acronyme HODL dans le monde crypto ?',
      en: 'What does the acronym HODL mean in the crypto world?'
    },
    options: {
      fr: [
        'High Order Digital Ledger',
        'Hold On for Dear Life - Conserver ses cryptos sur le long terme',
        'Highly Optimized Decentralized Liquidity',
        'Honest Open Distributed Ledger'
      ],
      en: [
        'High Order Digital Ledger',
        'Hold On for Dear Life - Keep your crypto long-term',
        'Highly Optimized Decentralized Liquidity',
        'Honest Open Distributed Ledger'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'HODL est né d\'une faute de frappe de "hold" sur un forum Bitcoin en 2013. Il signifie maintenant "Hold On for Dear Life" et désigne la stratégie de conserver ses cryptomonnaies sur le long terme sans vendre.',
      en: 'HODL originated from a typo of "hold" on a Bitcoin forum in 2013. It now means "Hold On for Dear Life" and refers to the strategy of keeping cryptocurrencies long-term without selling.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-002',
    category: 'general',
    difficulty: 'easy',
    question: {
      fr: 'Qu\'est-ce qu\'un altcoin ?',
      en: 'What is an altcoin?'
    },
    options: {
      fr: [
        'Une cryptomonnaie plus ancienne que Bitcoin',
        'Toute cryptomonnaie autre que Bitcoin',
        'Une cryptomonnaie alternative sans blockchain',
        'Un token non fongible'
      ],
      en: [
        'A cryptocurrency older than Bitcoin',
        'Any cryptocurrency other than Bitcoin',
        'An alternative cryptocurrency without blockchain',
        'A non-fungible token'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Altcoin est la contraction de "alternative coin". Ce terme désigne toutes les cryptomonnaies autres que Bitcoin, qu\'il s\'agisse d\'Ethereum, Litecoin, Cardano ou de milliers d\'autres.',
      en: 'Altcoin is short for "alternative coin". This term refers to all cryptocurrencies other than Bitcoin, whether Ethereum, Litecoin, Cardano, or thousands of others.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-003',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Quelle est la différence entre un token et une coin ?',
      en: 'What is the difference between a token and a coin?'
    },
    options: {
      fr: [
        'Il n\'y a aucune différence',
        'Un token est créé sur une blockchain existante, une coin a sa propre blockchain',
        'Une coin est uniquement Bitcoin',
        'Un token a plus de valeur qu\'une coin'
      ],
      en: [
        'There is no difference',
        'A token is created on an existing blockchain, a coin has its own blockchain',
        'A coin is only Bitcoin',
        'A token is worth more than a coin'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Une "coin" (comme Bitcoin, Ethereum) possède sa propre blockchain native. Un "token" (comme UNI, LINK) est créé sur une blockchain existante via un smart contract, sans avoir sa propre infrastructure.',
      en: 'A "coin" (like Bitcoin, Ethereum) has its own native blockchain. A "token" (like UNI, LINK) is created on an existing blockchain via a smart contract, without its own infrastructure.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-004',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce qu\'un stablecoin ?',
      en: 'What is a stablecoin?'
    },
    options: {
      fr: [
        'Une cryptomonnaie très ancienne et stable',
        'Une cryptomonnaie dont la valeur est stable, généralement adossée au dollar',
        'Un token utilisé uniquement pour le staking',
        'Une cryptomonnaie qui ne peut pas être transférée'
      ],
      en: [
        'A very old and stable cryptocurrency',
        'A cryptocurrency with a stable value, usually pegged to the dollar',
        'A token used only for staking',
        'A cryptocurrency that cannot be transferred'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Un stablecoin est une cryptomonnaie conçue pour maintenir une valeur stable, généralement adossée 1:1 à une monnaie fiat comme le dollar. Exemples : USDT, USDC, DAI. Ils servent de valeur refuge dans l\'écosystème crypto.',
      en: 'A stablecoin is a cryptocurrency designed to maintain a stable value, usually pegged 1:1 to a fiat currency like the dollar. Examples: USDT, USDC, DAI. They serve as a safe haven in the crypto ecosystem.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-005',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Que signifie TVL (Total Value Locked) en DeFi ?',
      en: 'What does TVL (Total Value Locked) mean in DeFi?'
    },
    options: {
      fr: [
        'Le nombre total de transactions verrouillées',
        'La valeur totale des actifs déposés dans un protocole DeFi',
        'Le temps de verrouillage des tokens',
        'Le volume total de trading journalier'
      ],
      en: [
        'The total number of locked transactions',
        'The total value of assets deposited in a DeFi protocol',
        'The token lock-up time',
        'The total daily trading volume'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'TVL (Total Value Locked) représente la valeur totale des actifs cryptographiques déposés dans un protocole DeFi. C\'est un indicateur clé de la taille et de l\'adoption d\'un protocole.',
      en: 'TVL (Total Value Locked) represents the total value of crypto assets deposited in a DeFi protocol. It\'s a key indicator of a protocol\'s size and adoption.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-006',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce que le "gas" sur Ethereum ?',
      en: 'What is "gas" on Ethereum?'
    },
    options: {
      fr: [
        'Une cryptomonnaie concurrente',
        'L\'unité mesurant le coût computationnel d\'une opération',
        'Un type de wallet',
        'Le nom du consensus Ethereum'
      ],
      en: [
        'A competing cryptocurrency',
        'The unit measuring the computational cost of an operation',
        'A type of wallet',
        'The name of Ethereum\'s consensus'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le gas est l\'unité de mesure du coût computationnel sur Ethereum. Chaque opération (transfert, swap, smart contract) coûte du gas. Le prix du gas (en gwei) multiplié par le gas utilisé détermine les frais de transaction.',
      en: 'Gas is the unit measuring computational cost on Ethereum. Each operation (transfer, swap, smart contract) costs gas. Gas price (in gwei) multiplied by gas used determines transaction fees.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-007',
    category: 'general',
    difficulty: 'hard',
    question: {
      fr: 'Qu\'est-ce que le "slashing" dans un système Proof of Stake ?',
      en: 'What is "slashing" in a Proof of Stake system?'
    },
    options: {
      fr: [
        'Une technique de trading rapide',
        'La réduction des frais de transaction',
        'La pénalité infligée à un validateur malhonnête qui perd une partie de ses tokens stakés',
        'Le processus de création de nouveaux tokens'
      ],
      en: [
        'A fast trading technique',
        'The reduction of transaction fees',
        'The penalty imposed on a dishonest validator who loses part of their staked tokens',
        'The process of creating new tokens'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Le slashing est un mécanisme de punition dans les systèmes PoS. Si un validateur agit de manière malhonnête (double signature, offline trop longtemps), une partie de ses tokens stakés est confisquée. Cela incite à un comportement honnête.',
      en: 'Slashing is a punishment mechanism in PoS systems. If a validator acts dishonestly (double signing, offline too long), part of their staked tokens is confiscated. This incentivizes honest behavior.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-008',
    category: 'general',
    difficulty: 'easy',
    question: {
      fr: 'Que signifie FUD dans la communauté crypto ?',
      en: 'What does FUD mean in the crypto community?'
    },
    options: {
      fr: [
        'Funds Under Development',
        'Fear, Uncertainty, Doubt - Peur, incertitude, doute',
        'Fast Unified Distribution',
        'Full User Decentralization'
      ],
      en: [
        'Funds Under Development',
        'Fear, Uncertainty, Doubt',
        'Fast Unified Distribution',
        'Full User Decentralization'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'FUD signifie "Fear, Uncertainty, Doubt" (Peur, Incertitude, Doute). Ce terme désigne les informations négatives, vraies ou fausses, qui créent la panique sur les marchés. "Ne FUD pas" signifie ne pas répandre de rumeurs négatives.',
      en: 'FUD stands for "Fear, Uncertainty, Doubt". This term refers to negative information, true or false, that creates panic in markets. "Don\'t FUD" means don\'t spread negative rumors.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-009',
    category: 'general',
    difficulty: 'hard',
    question: {
      fr: 'Qu\'est-ce qu\'un "rug pull" ?',
      en: 'What is a "rug pull"?'
    },
    options: {
      fr: [
        'Une technique de trading automatisé',
        'Une arnaque où les développeurs abandonnent un projet en emportant les fonds',
        'Une mise à jour de protocole',
        'Un type de smart contract sécurisé'
      ],
      en: [
        'An automated trading technique',
        'A scam where developers abandon a project taking the funds',
        'A protocol update',
        'A type of secure smart contract'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Un "rug pull" (littéralement "tirer le tapis") est une arnaque où les développeurs d\'un projet crypto disparaissent avec les fonds des investisseurs. C\'est fréquent sur les DEX où n\'importe qui peut créer un token.',
      en: 'A "rug pull" (literally "pulling the rug") is a scam where crypto project developers disappear with investors\' funds. It\'s common on DEXs where anyone can create a token.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-010',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce qu\'une "whale" (baleine) en crypto ?',
      en: 'What is a "whale" in crypto?'
    },
    options: {
      fr: [
        'Un type de smart contract',
        'Un détenteur d\'une très grande quantité de cryptomonnaie capable d\'influencer les prix',
        'Un exchange décentralisé',
        'Un protocole de confidentialité'
      ],
      en: [
        'A type of smart contract',
        'A holder of a very large amount of cryptocurrency capable of influencing prices',
        'A decentralized exchange',
        'A privacy protocol'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Une "whale" (baleine) est un investisseur détenant une très grande quantité d\'une cryptomonnaie. Leurs mouvements (achats, ventes) peuvent avoir un impact significatif sur les prix du marché.',
      en: 'A "whale" is an investor holding a very large amount of a cryptocurrency. Their moves (buys, sells) can have a significant impact on market prices.'
    },
    articleUrl: 'https://edouard.ai/lexique-crypto-termes-expliques',
    articleTitle: {
      fr: 'Lexique Crypto : Dictionnaire Complet des Termes Expliqués',
      en: 'Crypto Glossary: Complete Dictionary of Explained Terms'
    }
  },
  {
    id: 'gen-011',
    category: 'general',
    difficulty: 'easy',
    question: {
      fr: 'Pourquoi certains pays des BRICS s\'intéressent-ils à Bitcoin ?',
      en: 'Why are some BRICS countries interested in Bitcoin?'
    },
    options: {
      fr: [
        'Pour devenir des paradis fiscaux',
        'Pour réduire leur dépendance au dollar américain',
        'Pour créer des NFT nationaux',
        'Pour interdire les autres cryptomonnaies'
      ],
      en: [
        'To become tax havens',
        'To reduce their dependence on the US dollar',
        'To create national NFTs',
        'To ban other cryptocurrencies'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Les pays BRICS (Brésil, Russie, Inde, Chine, Afrique du Sud) cherchent à réduire leur dépendance au dollar américain. Bitcoin et les cryptos peuvent servir à contourner le système SWIFT et les sanctions occidentales.',
      en: 'BRICS countries (Brazil, Russia, India, China, South Africa) seek to reduce their dependence on the US dollar. Bitcoin and crypto can bypass the SWIFT system and Western sanctions.'
    },
    articleUrl: 'https://edouard.ai/bitcoin-etats-adoption-mondiale',
    articleTitle: {
      fr: 'Bitcoin et les États : La Course Mondiale à l\'Adoption',
      en: 'Bitcoin and Nations: The Global Race to Adoption'
    }
  },
  {
    id: 'gen-012',
    category: 'general',
    difficulty: 'hard',
    question: {
      fr: 'Pourquoi un pays ne peut-il pas vraiment "interdire" Bitcoin techniquement ?',
      en: 'Why can\'t a country really "ban" Bitcoin technically?'
    },
    options: {
      fr: [
        'Parce que c\'est trop populaire',
        'Parce que le réseau est décentralisé et accessible via VPN/Tor',
        'Parce que les autres pays s\'y opposeraient',
        'Parce que les banques l\'utilisent'
      ],
      en: [
        'Because it\'s too popular',
        'Because the network is decentralized and accessible via VPN/Tor',
        'Because other countries would oppose it',
        'Because banks use it'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Un pays peut interdire les exchanges et le mining sur son territoire, mais il ne peut pas empêcher techniquement les citoyens de détenir ou envoyer des BTC via VPN, Tor ou wallets personnels. La Chine l\'a montré : l\'interdiction n\'a pas éliminé l\'usage.',
      en: 'A country can ban exchanges and mining on its territory, but cannot technically prevent citizens from holding or sending BTC via VPN, Tor, or personal wallets. China showed this: the ban didn\'t eliminate usage.'
    },
    articleUrl: 'https://edouard.ai/bitcoin-etats-adoption-mondiale',
    articleTitle: {
      fr: 'Bitcoin et les États : La Course Mondiale à l\'Adoption',
      en: 'Bitcoin and Nations: The Global Race to Adoption'
    }
  },
  {
    id: 'gen-013',
    category: 'general',
    difficulty: 'easy',
    question: {
      fr: 'Que signifie CBDC ?',
      en: 'What does CBDC stand for?'
    },
    options: {
      fr: [
        'Crypto Bitcoin Digital Currency',
        'Central Bank Digital Currency',
        'Cross Border Digital Coin',
        'Community Blockchain Development Center'
      ],
      en: [
        'Crypto Bitcoin Digital Currency',
        'Central Bank Digital Currency',
        'Cross Border Digital Coin',
        'Community Blockchain Development Center'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'CBDC signifie "Central Bank Digital Currency" (Monnaie Numérique de Banque Centrale). C\'est une forme numérique de la monnaie fiduciaire, émise et garantie par une banque centrale.',
      en: 'CBDC stands for "Central Bank Digital Currency". It\'s a digital form of fiat currency, issued and guaranteed by a central bank.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-014',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Combien de pays explorent ou développent des CBDC en 2025 ?',
      en: 'How many countries are exploring or developing CBDCs in 2025?'
    },
    options: {
      fr: ['~50 pays', '~80 pays', '~130 pays', '~180 pays'],
      en: ['~50 countries', '~80 countries', '~130 countries', '~180 countries']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'En 2025, plus de 130 pays représentant 98% du PIB mondial explorent ou développent des CBDC. L\'euro numérique pourrait être lancé dès 2027-2028.',
      en: 'In 2025, over 130 countries representing 98% of global GDP are exploring or developing CBDCs. The digital euro could launch as early as 2027-2028.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-015',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Quel pays a le projet CBDC le plus avancé parmi les grandes économies ?',
      en: 'Which country has the most advanced CBDC project among major economies?'
    },
    options: {
      fr: ['États-Unis', 'Japon', 'Chine', 'Royaume-Uni'],
      en: ['United States', 'Japan', 'China', 'United Kingdom']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'La Chine est pionnière avec le yuan numérique (e-CNY). En 2025, il compte plus de 260 millions de portefeuilles créés et 180 milliards de yuans de transactions cumulées.',
      en: 'China is the pioneer with the digital yuan (e-CNY). In 2025, it has over 260 million wallets created and 180 billion yuan in cumulative transactions.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-016',
    category: 'general',
    difficulty: 'hard',
    question: {
      fr: 'Quel est le plafond de détention envisagé pour l\'euro numérique ?',
      en: 'What is the proposed holding limit for the digital euro?'
    },
    options: {
      fr: ['1 000€', '3 000€', '10 000€', 'Illimité'],
      en: ['€1,000', '€3,000', '€10,000', 'Unlimited']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le plafond de détention envisagé pour l\'euro numérique est d\'environ 3 000€. Au-delà, une conversion automatique vers un compte bancaire serait effectuée.',
      en: 'The proposed holding limit for the digital euro is approximately €3,000. Beyond this amount, automatic conversion to a bank account would be performed.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-017',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Quelle est la différence fondamentale entre une CBDC et Bitcoin concernant le contrôle ?',
      en: 'What is the fundamental difference between a CBDC and Bitcoin regarding control?'
    },
    options: {
      fr: [
        'Aucune, les deux sont décentralisés',
        'La CBDC est décentralisée, Bitcoin est centralisé',
        'La CBDC est contrôlée par la banque centrale, Bitcoin est décentralisé',
        'Les deux sont contrôlés par des entreprises privées'
      ],
      en: [
        'None, both are decentralized',
        'CBDC is decentralized, Bitcoin is centralized',
        'CBDC is controlled by the central bank, Bitcoin is decentralized',
        'Both are controlled by private companies'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'La différence fondamentale est le contrôle : une CBDC est émise et contrôlée par une banque centrale (centralisée), tandis que Bitcoin fonctionne sur un réseau décentralisé sans autorité centrale.',
      en: 'The fundamental difference is control: a CBDC is issued and controlled by a central bank (centralized), while Bitcoin operates on a decentralized network without central authority.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-018',
    category: 'general',
    difficulty: 'hard',
    question: {
      fr: 'Qu\'est-ce que la "programmabilité" d\'une CBDC permet potentiellement ?',
      en: 'What does CBDC "programmability" potentially allow?'
    },
    options: {
      fr: [
        'Rendre la monnaie plus rapide',
        'Fixer une date d\'expiration à l\'argent ou restreindre son usage',
        'Augmenter les rendements',
        'Créer des NFT gouvernementaux'
      ],
      en: [
        'Make the currency faster',
        'Set an expiration date on money or restrict its use',
        'Increase returns',
        'Create government NFTs'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'La programmabilité des CBDC permet des fonctionnalités controversées : date d\'expiration de l\'argent, restrictions géographiques, catégories de dépenses interdites, taux négatifs effectifs, ou gel instantané de comptes.',
      en: 'CBDC programmability allows controversial features: money expiration dates, geographic restrictions, prohibited spending categories, effective negative rates, or instant account freezing.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-019',
    category: 'general',
    difficulty: 'easy',
    question: {
      fr: 'Quelle est la principale préoccupation concernant les CBDC en termes de vie privée ?',
      en: 'What is the main privacy concern regarding CBDCs?'
    },
    options: {
      fr: [
        'Elles sont trop lentes',
        'Elles permettent une surveillance totale des transactions par l\'État',
        'Elles coûtent cher à utiliser',
        'Elles ne fonctionnent pas à l\'étranger'
      ],
      en: [
        'They are too slow',
        'They allow total state surveillance of transactions',
        'They are expensive to use',
        'They don\'t work abroad'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'La principale préoccupation est la surveillance : avec une CBDC, chaque transaction peut être enregistrée, l\'identité est vérifiée, et l\'historique complet est accessible aux autorités. C\'est le contraire du cash.',
      en: 'The main concern is surveillance: with a CBDC, every transaction can be recorded, identity is verified, and complete history is accessible to authorities. It\'s the opposite of cash.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-020',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Pourquoi dit-on que les CBDC sont une "réaction défensive" à Bitcoin ?',
      en: 'Why are CBDCs said to be a "defensive reaction" to Bitcoin?'
    },
    options: {
      fr: [
        'Parce qu\'elles copient le code de Bitcoin',
        'Parce que sans Bitcoin, les banques centrales n\'auraient jamais développé de monnaies numériques',
        'Parce qu\'elles utilisent la même blockchain',
        'Parce que Bitcoin a acheté les banques centrales'
      ],
      en: [
        'Because they copy Bitcoin\'s code',
        'Because without Bitcoin, central banks would never have developed digital currencies',
        'Because they use the same blockchain',
        'Because Bitcoin bought the central banks'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'C\'est une ironie historique : les CBDC sont une réaction défensive à Bitcoin. Sans la menace de la décentralisation et de la perte de contrôle monétaire, les banques centrales n\'auraient jamais développé leurs propres monnaies numériques.',
      en: 'It\'s a historical irony: CBDCs are a defensive reaction to Bitcoin. Without the threat of decentralization and loss of monetary control, central banks would never have developed their own digital currencies.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-021',
    category: 'general',
    difficulty: 'medium',
    question: {
      fr: 'Quel est le statut des CBDC aux États-Unis en 2025 ?',
      en: 'What is the status of CBDCs in the United States in 2025?'
    },
    options: {
      fr: [
        'CBDC déjà lancée',
        'Lancement prévu dans 6 mois',
        'Aucun lancement prévu, débats en cours',
        'Interdiction des CBDC votée'
      ],
      en: [
        'CBDC already launched',
        'Launch planned in 6 months',
        'No launch planned, debates ongoing',
        'CBDC ban voted'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'En 2025, aucun lancement de CBDC de détail n\'est prévu aux États-Unis. Il y a une opposition forte (notamment républicaine), un débat sur la liberté financière, et des recherches continuent prudemment.',
      en: 'In 2025, no retail CBDC launch is planned in the United States. There is strong opposition (notably Republican), debate over financial freedom, and research continues cautiously.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },
  {
    id: 'gen-022',
    category: 'general',
    difficulty: 'easy',
    question: {
      fr: 'Quelle proportion du PIB mondial est représentée par les pays explorant les CBDC ?',
      en: 'What proportion of global GDP is represented by countries exploring CBDCs?'
    },
    options: {
      fr: ['~50%', '~75%', '~98%', '~100%'],
      en: ['~50%', '~75%', '~98%', '~100%']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Les pays explorant ou développant des CBDC représentent 98% du PIB mondial. C\'est un mouvement quasi-universel des banques centrales face à la montée des cryptomonnaies.',
      en: 'Countries exploring or developing CBDCs represent 98% of global GDP. It\'s a near-universal movement by central banks in response to the rise of cryptocurrencies.'
    },
    articleUrl: 'https://edouard.ai/cbdc-vs-crypto-guerre-monnaies',
    articleTitle: {
      fr: 'CBDC vs Crypto : La Guerre des Monnaies Numériques',
      en: 'CBDC vs Crypto: The Digital Currency War'
    }
  },

  // ========================================
  // DEFI (8 questions)
  // ========================================

  {
    id: 'defi-001',
    category: 'defi',
    difficulty: 'easy',
    question: {
      fr: 'Que signifie CEX dans le contexte des exchanges crypto ?',
      en: 'What does CEX mean in the context of crypto exchanges?'
    },
    options: {
      fr: [
        'Crypto Exchange Expert',
        'Centralized Exchange - Plateforme d\'échange centralisée',
        'Cross-chain Exchange',
        'Community Exchange'
      ],
      en: [
        'Crypto Exchange Expert',
        'Centralized Exchange - Centralized trading platform',
        'Cross-chain Exchange',
        'Community Exchange'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'CEX signifie "Centralized Exchange" (exchange centralisé). C\'est une plateforme gérée par une entreprise qui détient les fonds des utilisateurs et effectue le matching des ordres. Exemples : Binance, Coinbase, Kraken.',
      en: 'CEX means "Centralized Exchange". It\'s a platform managed by a company that holds users\' funds and performs order matching. Examples: Binance, Coinbase, Kraken.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },
  {
    id: 'defi-002',
    category: 'defi',
    difficulty: 'easy',
    question: {
      fr: 'Qu\'est-ce qu\'un DEX ?',
      en: 'What is a DEX?'
    },
    options: {
      fr: [
        'Un exchange géré par une entreprise',
        'Un protocole d\'échange décentralisé fonctionnant via smart contracts',
        'Un type de cryptomonnaie',
        'Un wallet hardware'
      ],
      en: [
        'An exchange managed by a company',
        'A decentralized exchange protocol operating via smart contracts',
        'A type of cryptocurrency',
        'A hardware wallet'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Un DEX (Decentralized Exchange) est une plateforme d\'échange décentralisée qui fonctionne via des smart contracts. Les utilisateurs gardent le contrôle de leurs fonds et n\'ont pas besoin de créer de compte ou passer par un KYC.',
      en: 'A DEX (Decentralized Exchange) is a decentralized trading platform that operates via smart contracts. Users maintain control of their funds and don\'t need to create an account or go through KYC.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },
  {
    id: 'defi-003',
    category: 'defi',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce qu\'un AMM (Automated Market Maker) ?',
      en: 'What is an AMM (Automated Market Maker)?'
    },
    options: {
      fr: [
        'Un robot de trading automatisé',
        'Un protocole utilisant des pools de liquidité pour faciliter les échanges',
        'Un type d\'ordre limite automatique',
        'Un système de minage automatisé'
      ],
      en: [
        'An automated trading bot',
        'A protocol using liquidity pools to facilitate exchanges',
        'A type of automatic limit order',
        'An automated mining system'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Un AMM est un protocole qui utilise des pools de liquidité et des formules mathématiques (comme x*y=k) pour déterminer les prix, au lieu d\'un carnet d\'ordres traditionnel. Uniswap et Curve sont des exemples d\'AMM.',
      en: 'An AMM is a protocol that uses liquidity pools and mathematical formulas (like x*y=k) to determine prices, instead of a traditional order book. Uniswap and Curve are examples of AMMs.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },
  {
    id: 'defi-004',
    category: 'defi',
    difficulty: 'medium',
    question: {
      fr: 'Quel est l\'avantage principal d\'un DEX par rapport à un CEX ?',
      en: 'What is the main advantage of a DEX over a CEX?'
    },
    options: {
      fr: [
        'Les frais sont toujours plus bas',
        'La liquidité est meilleure',
        'L\'utilisateur garde le contrôle de ses fonds (self-custody)',
        'Le support client est meilleur'
      ],
      en: [
        'Fees are always lower',
        'Liquidity is better',
        'User keeps control of their funds (self-custody)',
        'Customer support is better'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'L\'avantage principal d\'un DEX est le self-custody : vous gardez le contrôle de vos fonds. Contrairement aux CEX, vous n\'avez pas à faire confiance à une entreprise pour garder vos cryptos. Pas de risque de faillite comme FTX.',
      en: 'The main advantage of a DEX is self-custody: you keep control of your funds. Unlike CEXs, you don\'t have to trust a company to hold your crypto. No risk of bankruptcy like FTX.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },
  {
    id: 'defi-005',
    category: 'defi',
    difficulty: 'hard',
    question: {
      fr: 'Combien de milliards de dollars ont été perdus lors de la faillite de FTX en 2022 ?',
      en: 'How many billions of dollars were lost in the FTX bankruptcy in 2022?'
    },
    options: {
      fr: ['~2 milliards $', '~5 milliards $', '~8 milliards $', '~15 milliards $'],
      en: ['~$2 billion', '~$5 billion', '~$8 billion', '~$15 billion']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'La faillite de FTX en novembre 2022 a entraîné la perte d\'environ 8 milliards de dollars de fonds clients. C\'est l\'un des plus grands scandales de l\'histoire crypto et illustre les risques des exchanges centralisés.',
      en: 'The FTX bankruptcy in November 2022 resulted in the loss of approximately $8 billion in customer funds. It\'s one of the biggest scandals in crypto history and illustrates the risks of centralized exchanges.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },
  {
    id: 'defi-006',
    category: 'defi',
    difficulty: 'hard',
    question: {
      fr: 'Quel est le frais de swap typique sur Uniswap ?',
      en: 'What is the typical swap fee on Uniswap?'
    },
    options: {
      fr: ['0.05%', '0.1%', '0.3%', '1%'],
      en: ['0.05%', '0.1%', '0.3%', '1%']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Les frais de swap standard sur Uniswap sont de 0.3% (30 points de base). Ces frais vont aux fournisseurs de liquidité. À noter que les frais de gas Ethereum s\'ajoutent à ces frais de protocole.',
      en: 'The standard swap fee on Uniswap is 0.3% (30 basis points). These fees go to liquidity providers. Note that Ethereum gas fees are added on top of these protocol fees.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },
  {
    id: 'defi-007',
    category: 'defi',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce que le slippage sur un DEX ?',
      en: 'What is slippage on a DEX?'
    },
    options: {
      fr: [
        'Les frais de réseau',
        'La différence entre le prix attendu et le prix réel d\'exécution',
        'Le temps de confirmation',
        'Le spread entre achat et vente'
      ],
      en: [
        'Network fees',
        'The difference between expected price and actual execution price',
        'Confirmation time',
        'The spread between buy and sell'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le slippage est la différence entre le prix que vous attendez et le prix réel auquel votre transaction est exécutée. Il est plus important sur les DEX avec faible liquidité ou pour les gros ordres.',
      en: 'Slippage is the difference between the price you expect and the actual price at which your transaction is executed. It\'s higher on DEXs with low liquidity or for large orders.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },
  {
    id: 'defi-008',
    category: 'defi',
    difficulty: 'medium',
    question: {
      fr: 'Quelle proportion du trading crypto se fait sur les DEX (2025) ?',
      en: 'What proportion of crypto trading is done on DEXs (2025)?'
    },
    options: {
      fr: ['~5%', '~15%', '~35%', '~50%'],
      en: ['~5%', '~15%', '~35%', '~50%']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Environ 15% du trading crypto se fait sur les DEX en 2025, et cette proportion est en hausse. Les CEX représentent encore ~1 500 milliards $ de volume mensuel contre ~200 milliards $ pour les DEX.',
      en: 'About 15% of crypto trading is done on DEXs in 2025, and this proportion is increasing. CEXs still represent ~$1.5 trillion in monthly volume compared to ~$200 billion for DEXs.'
    },
    articleUrl: 'https://edouard.ai/dex-vs-cex-comparatif-complet',
    articleTitle: {
      fr: 'DEX vs CEX : Comparatif Complet des Exchanges Crypto en 2025',
      en: 'DEX vs CEX: Complete Comparison of Crypto Exchanges in 2025'
    }
  },

  // ========================================
  // STAKING (7 questions)
  // ========================================

  {
    id: 'staking-001',
    category: 'staking',
    difficulty: 'easy',
    question: {
      fr: 'Qu\'est-ce que le staking en cryptomonnaie ?',
      en: 'What is staking in cryptocurrency?'
    },
    options: {
      fr: [
        'Acheter des cryptos régulièrement',
        'Immobiliser des cryptos pour participer à la validation d\'un réseau Proof of Stake',
        'Vendre ses cryptos au plus haut',
        'Miner des bitcoins avec un ordinateur'
      ],
      en: [
        'Buying crypto regularly',
        'Locking up crypto to participate in validating a Proof of Stake network',
        'Selling your crypto at the highest price',
        'Mining bitcoins with a computer'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le staking consiste à immobiliser des crypto-actifs pour participer à la validation des transactions sur un réseau Proof of Stake (PoS), en échange de récompenses sous forme de nouveaux tokens.',
      en: 'Staking involves locking up crypto assets to participate in transaction validation on a Proof of Stake (PoS) network, in exchange for rewards in the form of new tokens.'
    },
    articleUrl: 'https://edouard.ai/staking-crypto-guide-fiscalite-france',
    articleTitle: {
      fr: 'Staking Crypto : Guide Complet et Fiscalité en France',
      en: 'Crypto Staking: Complete Guide and Taxation in France'
    }
  },
  {
    id: 'staking-002',
    category: 'staking',
    difficulty: 'hard',
    question: {
      fr: 'Quel est le minimum d\'ETH requis pour faire du staking solo sur Ethereum ?',
      en: 'What is the minimum ETH required for solo staking on Ethereum?'
    },
    options: {
      fr: ['1 ETH', '10 ETH', '32 ETH', '100 ETH'],
      en: ['1 ETH', '10 ETH', '32 ETH', '100 ETH']
    },
    correctAnswer: 2,
    explanation: {
      fr: 'Le staking natif sur Ethereum nécessite un minimum de 32 ETH pour faire tourner un nœud validateur. C\'est un investissement conséquent qui explique le succès des solutions de staking liquide comme Lido.',
      en: 'Native staking on Ethereum requires a minimum of 32 ETH to run a validator node. It\'s a significant investment that explains the success of liquid staking solutions like Lido.'
    },
    articleUrl: 'https://edouard.ai/staking-crypto-guide-fiscalite-france',
    articleTitle: {
      fr: 'Staking Crypto : Guide Complet et Fiscalité en France',
      en: 'Crypto Staking: Complete Guide and Taxation in France'
    }
  },
  {
    id: 'staking-003',
    category: 'staking',
    difficulty: 'medium',
    question: {
      fr: 'Quel est le rendement approximatif du staking Ethereum (2025) ?',
      en: 'What is the approximate Ethereum staking yield (2025)?'
    },
    options: {
      fr: ['1-2% APY', '3-5% APY', '10-15% APY', '25-30% APY'],
      en: ['1-2% APY', '3-5% APY', '10-15% APY', '25-30% APY']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le staking Ethereum offre un rendement d\'environ 3-5% APY. Ce taux varie selon les conditions du réseau. C\'est un rendement modéré mais sur un actif de premier plan.',
      en: 'Ethereum staking offers a yield of approximately 3-5% APY. This rate varies depending on network conditions. It\'s a moderate return but on a top-tier asset.'
    },
    articleUrl: 'https://edouard.ai/staking-crypto-guide-fiscalite-france',
    articleTitle: {
      fr: 'Staking Crypto : Guide Complet et Fiscalité en France',
      en: 'Crypto Staking: Complete Guide and Taxation in France'
    }
  },
  {
    id: 'staking-004',
    category: 'staking',
    difficulty: 'medium',
    question: {
      fr: 'Qu\'est-ce que le "staking liquide" ?',
      en: 'What is "liquid staking"?'
    },
    options: {
      fr: [
        'Staker des cryptos sans les immobiliser',
        'Recevoir un token liquide (comme stETH) en échange de ses ETH stakés',
        'Faire du staking sur un exchange liquide',
        'Staker uniquement des stablecoins'
      ],
      en: [
        'Staking crypto without locking it up',
        'Receiving a liquid token (like stETH) in exchange for your staked ETH',
        'Staking on a liquid exchange',
        'Staking only stablecoins'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le staking liquide (via Lido, Rocket Pool) permet de recevoir un token représentatif (stETH, rETH) en échange de ses ETH stakés. Ce token reste liquide et utilisable en DeFi, combinant rendement et flexibilité.',
      en: 'Liquid staking (via Lido, Rocket Pool) allows you to receive a representative token (stETH, rETH) in exchange for your staked ETH. This token remains liquid and usable in DeFi, combining yield and flexibility.'
    },
    articleUrl: 'https://edouard.ai/staking-crypto-guide-fiscalite-france',
    articleTitle: {
      fr: 'Staking Crypto : Guide Complet et Fiscalité en France',
      en: 'Crypto Staking: Complete Guide and Taxation in France'
    }
  },
  {
    id: 'staking-005',
    category: 'staking',
    difficulty: 'hard',
    question: {
      fr: 'Quel est le rendement approximatif du staking Polkadot (DOT) ?',
      en: 'What is the approximate Polkadot (DOT) staking yield?'
    },
    options: {
      fr: ['3-5% APY', '10-14% APY', '20-25% APY', '50% APY'],
      en: ['3-5% APY', '10-14% APY', '20-25% APY', '50% APY']
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Polkadot offre des rendements de staking parmi les plus élevés des grandes cryptos, autour de 10-14% APY. Ceci s\'explique par son modèle NPoS (Nominated Proof of Stake).',
      en: 'Polkadot offers some of the highest staking yields among major cryptocurrencies, around 10-14% APY. This is explained by its NPoS (Nominated Proof of Stake) model.'
    },
    articleUrl: 'https://edouard.ai/staking-crypto-guide-fiscalite-france',
    articleTitle: {
      fr: 'Staking Crypto : Guide Complet et Fiscalité en France',
      en: 'Crypto Staking: Complete Guide and Taxation in France'
    }
  },
  {
    id: 'staking-006',
    category: 'staking',
    difficulty: 'easy',
    question: {
      fr: 'Quelle est la différence principale entre le mining (PoW) et le staking (PoS) ?',
      en: 'What is the main difference between mining (PoW) and staking (PoS)?'
    },
    options: {
      fr: [
        'Le mining est légal, le staking non',
        'Le mining utilise la puissance de calcul, le staking utilise le capital immobilisé',
        'Le mining est plus rentable que le staking',
        'Il n\'y a pas de différence'
      ],
      en: [
        'Mining is legal, staking is not',
        'Mining uses computing power, staking uses locked capital',
        'Mining is more profitable than staking',
        'There is no difference'
      ]
    },
    correctAnswer: 1,
    explanation: {
      fr: 'Le mining (Proof of Work) nécessite de la puissance de calcul et une consommation électrique élevée. Le staking (Proof of Stake) nécessite d\'immobiliser du capital. Le staking est moins énergivore.',
      en: 'Mining (Proof of Work) requires computing power and high electricity consumption. Staking (Proof of Stake) requires locking up capital. Staking is less energy-intensive.'
    },
    articleUrl: 'https://edouard.ai/staking-crypto-guide-fiscalite-france',
    articleTitle: {
      fr: 'Staking Crypto : Guide Complet et Fiscalité en France',
      en: 'Crypto Staking: Complete Guide and Taxation in France'
    }
  },
  {
    id: 'staking-007',
    category: 'staking',
    difficulty: 'medium',
    question: {
      fr: 'Les récompenses de staking sont-elles imposables en France ?',
      en: 'Are staking rewards taxable in France?'
    },
    options: {
      fr: [
        'Non, jamais',
        'Seulement si vous vendez vos cryptos',
        'Oui, elles sont considérées comme des revenus imposables',
        'Uniquement au-dessus de 10 000€'
      ],
      en: [
        'No, never',
        'Only if you sell your crypto',
        'Yes, they are considered taxable income',
        'Only above €10,000'
      ]
    },
    correctAnswer: 2,
    explanation: {
      fr: 'En France, les récompenses de staking sont considérées comme des revenus imposables. La position prudente est de les déclarer à leur réception, valorisées au cours du jour (généralement en BNC).',
      en: 'In France, staking rewards are considered taxable income. The prudent approach is to declare them upon receipt, valued at the day\'s rate (generally as BNC - non-commercial profits).'
    },
    articleUrl: 'https://edouard.ai/staking-crypto-guide-fiscalite-france',
    articleTitle: {
      fr: 'Staking Crypto : Guide Complet et Fiscalité en France',
      en: 'Crypto Staking: Complete Guide and Taxation in France'
    }
  }
];

// Helper functions
export const getQuestionsByCategory = (category: QuizCategory): QuizQuestion[] => {
  return QUIZ_QUESTIONS.filter(q => q.category === category);
};

export const getQuestionsByDifficulty = (difficulty: 'easy' | 'medium' | 'hard'): QuizQuestion[] => {
  return QUIZ_QUESTIONS.filter(q => q.difficulty === difficulty);
};

export const getRandomQuestion = (excludeIds: string[] = []): QuizQuestion | null => {
  const available = QUIZ_QUESTIONS.filter(q => !excludeIds.includes(q.id));
  if (available.length === 0) return null;
  return available[Math.floor(Math.random() * available.length)];
};

export const getQuestionById = (id: string): QuizQuestion | undefined => {
  return QUIZ_QUESTIONS.find(q => q.id === id);
};

export const CATEGORY_INFO: Record<QuizCategory, { label: string; icon: string; color: string }> = {
  'blockchain-basics': { label: 'Blockchain', icon: 'Blocks', color: '#667eea' },
  'defi': { label: 'DeFi', icon: 'Coins', color: '#06b6d4' },
  'staking': { label: 'Staking', icon: 'Lock', color: '#10b981' },
  'trading': { label: 'Trading', icon: 'TrendingUp', color: '#f59e0b' },
  'security': { label: 'Sécurité', icon: 'Shield', color: '#ef4444' },
  'flux': { label: 'Flux', icon: 'Server', color: '#2563eb' },
  'hedera': { label: 'Hedera', icon: 'Hash', color: '#8b5cf6' },
  'bitcoin': { label: 'Bitcoin', icon: 'Bitcoin', color: '#f7931a' },
  'ethereum': { label: 'Ethereum', icon: 'Hexagon', color: '#627eea' },
  'general': { label: 'Général', icon: 'HelpCircle', color: '#6b7280' }
};

// Statistics
// Total: 82 questions
// - bitcoin: 21
// - blockchain-basics: 8
// - security: 16
// - general: 22
// - defi: 8
// - staking: 7
// - trading: 0 (à ajouter)
// - flux: 0 (à ajouter)
// - hedera: 0 (à ajouter)
// - ethereum: 0 (à ajouter)
